import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BUYBOX_EXP_5:control
// ?preferred_variant=BUYBOX_EXP_5:variant_1
// ?preferred_variant=BUYBOX_EXP_5:variant_2

export const BuyboxExp5Name = 'BUYBOX_EXP_5' as const;

export type BuyboxExp5Variants = ToVariants<typeof BuyboxExp5Variants>;

export const BuyboxExp5Variants = {
	/** Current BuyBox */
	CONTROL: 'control',
	/** Last V2 (winner) with filter below promoted buybox */
	VARIANT_1: 'variant_1',
	/** Free trial additions/changes */
	VARIANT_2: 'variant_2',
} as const;

export default generate(BuyboxExp5Name, BuyboxExp5Variants);
